import React, { useState } from "react";
import styled from "styled-components";
import startsWith from "lodash/startsWith";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import Button from "../shared/Button";
import useEstatesFilterStore from "../stores/useEstatesFilterStore";
import EstateFilterModal from "./EstateFilterModal";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { SEARCH_FIELDS } from "../../services/EstateService";

const SearchBar = () => {
  const search = useEstatesFilterStore((state) => state.search);
  const searchFilter = useEstatesFilterStore((state) => state.searchFilter);
  const setSearch = useEstatesFilterStore((state) => state.setSearch);

  const [searchTmp, setSearchTmp] = useState(search);
  const [searchFilterTmp, setSearchFilterTmp] = useState(searchFilter);
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleSearch = () => setSearch(searchTmp, searchFilterTmp);

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (startsWith(value, "#")) setSearchFilterTmp("id");
    setSearchTmp(value);
  };
  const handleFilterChange = (e) => setSearchFilterTmp(e.target.value);
  const clearSearch = () => setSearchTmp("");
  const toggleFilterDisplay = (value) => () => setIsFilterOpen(value);

  return (
    <StyleWrapper className="search-bar row">
      <TextField
        className="search-bar__input col"
        size="small"
        variant="outlined"
        placeholder="Recherchez par ID..."
        value={searchTmp}
        onChange={handleInputChange}
        slotProps={{
          input: {
            endAdornment: (
              <>
                {!!searchTmp && (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      aria-label="Effacer"
                      onClick={clearSearch}
                    >
                      <CloseIcon />
                    </IconButton>
                  </InputAdornment>
                )}
                <InputAdornment position="end">
                  <Select
                    className="select"
                    size="small"
                    sx={{ minWidth: 200 }}
                    value={searchFilterTmp}
                    onChange={handleFilterChange}
                  >
                    {SEARCH_FIELDS.map((field) => (
                      <MenuItem key={field.value} value={field.value}>
                        {field.label}
                      </MenuItem>
                    ))}
                  </Select>
                </InputAdornment>
                <InputAdornment position="end" sx={{ ml: 0 }}>
                  <IconButton
                    edge="end"
                    aria-label="Rechercher"
                    onClick={handleSearch}
                    className="search-bar__input__button"
                    disableRipple
                  >
                    <ArrowForwardIcon htmlColor="var(--white)" fontSize="small" />
                  </IconButton>
                </InputAdornment>
              </>
            ),
          },
        }}
      />
      <Button
        className="col-auto"
        icon={<i className="bi bi-funnel" />}
        onClick={toggleFilterDisplay(true)}
      >
        Filtre
      </Button>
      {/* <Button
        className="col-auto"
        color="primary"
        variant="contained"
        icon={<AddIcon />}
      >
        Créer un nouveau bien
      </Button> */}
      <EstateFilterModal
        isOpen={isFilterOpen}
        handleClose={toggleFilterDisplay(false)}
      />
    </StyleWrapper>
  );
};

const StyleWrapper = styled.div`
  &.search-bar {
    gap: 12px;
  }

  .bi-funnel {
    color: var(--red-color);
  }

  .search-bar__input :not(.select) fieldset {
    border: 1px solid var(--menu-active-color);
  }

  .search-bar__input .select fieldset {
    border: none;
    border-left: 1px solid var(--menu-active-color);
    border-right: 1px solid var(--menu-active-color);
  }

  button.search-bar__input__button {
    background-color: var(--blue);
    margin-left: 0;
    border-radius: 0 4px 4px 0;
  }
`;

export default SearchBar;
